import React from 'react';

type NairaBagSize = 'sm' | 'md' | 'lg';

interface NairaBagTextProps {
  text: string;
  size?: NairaBagSize;
}

const sizeClassMap: Record<NairaBagSize, string> = {
  sm: 'naira-bag-sm',
  md: 'naira-bag-md',
  lg: 'naira-bag-lg',
};

export const NairaBagText: React.FC<NairaBagTextProps> = ({
  text,
  size = 'md',
}) => {
  // Parse the text to detect size parameter
  // Format: [NAIRA_BAG:lg] or [NAIRA_BAG:md] or just [NAIRA_BAG]
  const parseText = (input: string): { detectedSize: NairaBagSize | null; cleanText: string } => {
    const sizeMatch = input.match(/\[NAIRA_BAG:(\w+)\]/);
    if (sizeMatch) {
      const detectedSize = sizeMatch[1] as NairaBagSize;
      const cleanText = input.replace(/\[NAIRA_BAG:\w+\]/, '');
      return { detectedSize, cleanText };
    }
    return { detectedSize: null, cleanText: input };
  };

  const { detectedSize, cleanText } = parseText(text);
  const finalSize = detectedSize || size;
  const parts = cleanText.split('[NAIRA_BAG]');

  return (
    <>
      {parts.map((part, index) => (
        <React.Fragment key={index}>
          {index > 0 && (
            <img
              src="/money_bag_1_trans.png"
              alt="Naira Bag"
              className={`naira-bag-icon ${sizeClassMap[finalSize]}`}
            />
          )}
          {part}
        </React.Fragment>
      ))}
    </>
  );
};